"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dkCountry = void 0;
var _utils = require("../utils");
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var dkCountry = exports.dkCountry = function dkCountry(t) {
  return {
    id: 'DK',
    name: t('Denmark'),
    flag: '🇩🇰',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1050 or 8000',
    phonePrefix: '45',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Copenhagen',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.DK,
      checker: _companyNumber.checkers.DK,
      placeholder: '32345794'
    }
  };
};